/* 🤖 this file was generated by svg-to-ts */
export const emperorIconCalendarShield: {
  name: 'calendar_shield';
  data: string;
} = {
  name: 'calendar_shield',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0-.01h24v24H0Z"/><g><path d="M10 18H2V8h15.99v1h2V5c0-1.11-.9-2-2-2h-1V0h-2v5h-1V3h-7V0h-2v5h-1V3h-2c-1.103 0-2 .89-2 2v13c0 1.1.897 2 2 2h8v-2Z"/><path d="M12 11v7c0 3.81 3.79 5.57 5.8 5.98l.19.03 .19-.04c2-.41 5.8-2.17 5.8-5.98v-7h-12Zm10 7c0 2.76-3.154 3.75-4 3.97 -.83-.22-4.01-1.23-4.01-3.98v-5h8v5Z"/><path d="M17 20l2 0 0-2 2 0 0-2 -2 0 0-2 -2 0 0 2 -2 0 0 2 2 0Z"/></g></svg>`,
};
